import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AlertController, IonContent, LoadingController, ToastController } from '@ionic/angular';


import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { Stylist } from '../../models/stylist/stylist.model';
import { UserService } from '../../services/user.service';
import { StylistService } from '../../services/stylist.service';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.page.html',
  styleUrls: ['./notification-settings.page.scss'],
})
export class NotificationSettingsPage implements OnInit {

  @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public submitted: boolean;

  public savingInProgress: boolean;

  public stylistID: number;

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public notificationSettingsForm: UntypedFormGroup;

  public notifyForAllStaffActivity: UntypedFormControl;

  public newBookingNotification: UntypedFormControl;

  public editBookingNotification: UntypedFormControl;

  public deleteBookingNotification: UntypedFormControl;

  public waitListRequestNotification: UntypedFormControl;

  public notifyForAllStaffActivitySelectOptions: List<{label: string, value: number}>;


  constructor(
    //private navCtrl: NavController,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private readonly alertService: AlertService,
    private loadingCtrl: LoadingController,
    private readonly toastService: ToastService,


    private stylistService: StylistService) {

      this.isLoading = false;
      this.submitted = false;
      this.savingInProgress = false;
      this.notifyForAllStaffActivity = new UntypedFormControl(0, Validators.required);
      this.newBookingNotification = new UntypedFormControl(false, Validators.required);
      this.editBookingNotification = new UntypedFormControl(false, Validators.required);
      this.deleteBookingNotification = new UntypedFormControl(false, Validators.required);
      this.waitListRequestNotification = new UntypedFormControl(false, Validators.required);
      this.notificationSettingsForm = this.formBuilder.group({
        notifyForAllStaffActivity: this.notifyForAllStaffActivity,
        newBookingNotification: this.newBookingNotification,
        editBookingNotification: this.editBookingNotification,
        deleteBookingNotification: this.deleteBookingNotification,
        waitListRequestNotification: this.waitListRequestNotification
      });
      this.notifyForAllStaffActivitySelectOptions = List.of(
        {label: 'Just my activity', value: 0},
        {label: 'All staff activity', value: 1}
      );
  

    this.readOnlyStylistPicker = true;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator()) {
        this.readOnlyStylistPicker = false;
      }
    }
  }

  ngOnInit() {
  }



  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      // this.content.resize();
    }
  }

  public onTapToReload () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.stylistPickerComponent.ngOnInit();      
  }
  public onStylistSelect (stylist: Stylist) {
    this.isLoading = true;
    if (stylist) {
      this.stylist = stylist;
      this.stylistID = this.stylist.getID();
      this.notificationSettingsForm.reset();
      this.notifyForAllStaffActivity.setValue(this.stylist.getNotifyForAllStaffActivity());
      this.newBookingNotification.setValue(this.stylist.getNewBookingNotification());
      this.editBookingNotification.setValue(this.stylist.getEditBookingNotification());
      this.deleteBookingNotification.setValue(this.stylist.getDeleteBookingNotification());
      this.waitListRequestNotification.setValue(this.stylist.getWaitListRequestNotification());
    }
    this.isLoading = false;
  }

  public async onNotificationSettingsFormSave () {
    this.submitted = true;

    if (this.notificationSettingsForm.valid === false) {
      return;
    }

    this.stylist = this.stylist.setNotifyForAllStaffActivity(this.notifyForAllStaffActivity.value);
    this.stylist = this.stylist.setNewBookingNotification(this.newBookingNotification.value ? 1 : 0);
    this.stylist = this.stylist.setEditBookingNotification(this.editBookingNotification.value ? 1 : 0);
    this.stylist = this.stylist.setDeleteBookingNotification(this.deleteBookingNotification.value ? 1 : 0);
    this.stylist = this.stylist.setWaitListRequestNotification(this.waitListRequestNotification.value ? 1 : 0);
    this.savingInProgress = true;

      const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();
    this.stylistService.saveStylist(this.stylist)
    .subscribe({
      next: (result) => {

        loader.dismiss().then(() => {
          this.savingInProgress = false;
          this.submitted = false;
          this.stylistService.updateStylist(this.stylist);
          this.toastService.presentSimpleToast(`Notification settings have been successfully updated.`, 3000);
          //this.navCtrl.pop();
          this.router.navigateByUrl('/settings');
        });
      },
      error: (e) => {
        loader.dismiss().then(() => {
          this.savingInProgress = false;
          this.alertService.presentErrorAlert();
        });
      }      
    });
  }

  public onBack () {
    //this.navCtrl.pop();
    this.router.navigateByUrl('/settings');
  }

}
